import React from 'react';
import { hydrate, render } from 'react-dom';
import { Provider } from 'react-redux';
import { configureStore } from './store';
import App from './App';
import { icons } from './assets/icons';
import reportWebVitals from './reportWebVitals';
// import TagManager from 'react-gtm-module';

React.icons = icons; // Make @coreui/icons-react & @coreui/icons work
const store = configureStore();

// const tagManagerArgs = {
//     gtmId: 'GTM-000000'
// };

// TagManager.initialize(tagManagerArgs);

//Testing deployment

const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
     hydrate(
          <Provider store={store}>
               <App />
          </Provider>,
          rootElement
     );
} else {
     render(
          <Provider store={store}>
               <App />
          </Provider>,
          rootElement
     );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
